import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import Marquee3k from 'marquee3000';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import { Gallery } from './gallery.js';
import Macy from 'macy';
// import Vibrant from 'node-vibrant/dist/vibrant.min';
// import MiniMasonry from "minimasonry";


const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const swup = new Swup({
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupScriptsPlugin({
      optin: true
    })
  ]
});

let macyLoaded = false;
let macy;

function lazyGallery() {
	for (const elem of document.querySelectorAll('.lazy-gallery')) {
		const gallery = new Gallery(elem);
	}
}




// Events
swup.on('contentReplaced', function(){
  init();
  loadMacy();
});


// Start Apline after swup so it works correctly
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.store('gallery', {age: [], county: [], theme: [], medium: [], technique: [], genre: [], sort: ''})
Alpine.store('search', {query: 'Search'})
Alpine.data('filterButton', (filter, value) => ({
	active: false,
	filter: filter,
	value: value,
	handleFilterUpdate(event) {
		if (event.detail[this.filter]) {
			this.active = event.detail[this.filter].includes(this.value)
		}
	},
	handleClick() {
		if(this.mobile) {
			this.filterMenu = false;
		}
		this.active = !this.active
		if (this.active) {
			this.$store.gallery[this.filter].push(this.value)
		} else {
			this.$store.gallery[this.filter] = this.$store.gallery[this.filter].filter(item => item !== this.value)
		}
		if (window.filter) {
			window.filter(this.$store.gallery)
		} else {
			console.log('no filter')
		}
	},
}));

window.Alpine = Alpine
Alpine.start();


document.addEventListener("DOMContentLoaded", () => {
	init()
	loadMacy()
});

// Functions
function l(m) {
  console.log(m);
}

let scrollVideo;
// let msnry;

function init() {
  l('👍');
	window.scrollTo(0,0);
	articleColors();
  atvImg();
  startSliders();
	lazyGallery();
	scrollVideoFn();
  Marquee3k.init()

	// masonryLayout()

}

function loadMacy() {
  if(document.querySelector('.gallery_listing')) {
    l('loadMacy');
    macyLoaded = true;
    // Masonry style layout
    macy = Macy({
      container: '.gallery_listing',
      trueOrder: false,
      waitForImages: false,
      margin: 35,
      columns: 4,
      breakAt: {
          1600: {
            margin: {
              x: 35,
              y: 35,
            },
            columns: 3
          },
          1200: {
            margin: {
              x: 35,
              y: 35,
            },
            columns: 3
          },
          960: {
            margin: {
              x: 20,
              y: 20,
            },
            columns: 3
          },
          520: {
            margin: {
              x: 20,
              y: 20,
            },
            columns: 2
          },
          400: {
            margin: {
              x: 0,
              y: 20,
            },
            columns: 2
          }
      }
    });
	  window.macy = macy;
    macy.runOnImageLoad(function () {
      // console.log('Every time an image loads I get fired');
      macy.recalculate(true);
    }, true);

    window.addEventListener('imageReload', e => {
      macy.recalculate(true);
    });
  }
}

window.loadMacy = loadMacy;


function scrollVideoFn() {
	if(document.querySelector('.scrollvideo')) {
		scrollVideo = document.querySelector('.scrollvideo');
		if(scrollVideo) {
			scrollVideo.addEventListener('loadeddata', handleLoadedData);
		}
	}
}


// function masonryLayout() {

	// var elem = document.querySelector('.blog_latest');

	// msnry = new Masonry( elem, {
	// 	gutter: 30,
	// 	itemSelector: '.blog_tile',
	// 	percentPosition: true,
	// 	horizontalOrder: true
	// });

	// setTimeout(()=> {
	// 	msnry.layout();
	// }, 200)

// }

function startSliders() {
  if(document.querySelectorAll('.splide').length) {
    let perPage = isMobile ? 1.5 : 3.5;
    let splide = new Splide( '.splide', {
      type: 'loop',
      focus  : 'left',
      perPage: perPage,
      arrows: true,
      pagination: false,
      autoWidth: true
    });
    splide.mount();
  }
}

// function loadMacy() {
//   if(document.querySelector('.blog_latest')) {
//     l('loadMacy');
//     macyLoaded = true;
//     // Masonry style layout
//     macy = Macy({
//       container: '.gallery_listing',
//       trueOrder: false,
//       waitForImages: false,
//       margin: 30,
//       columns: 5,
//       breakAt: {
//           1600: {
//             margin: {
//               x: 30,
//               y: 30,
//             },
//             columns: 6
//           },
//           1200: {
//             margin: {
//               x: 30,
//               y: 30,
//             },
//             columns: 4
//           },
//           960: {
//             margin: {
//               x: 20,
//               y: 20,
//             },
//             columns: 3
//           },
//           520: {
//             margin: {
//               x: 20,
//               y: 20,
//             },
//             columns: 2
//           },
//           400: {
//             margin: {
//               x: 0,
//               y: 20,
//             },
//             columns: 1
//           }
//       }
//     });

//     macy.runOnImageLoad(function () {
//       console.log('Every time an image loads I get fired');
//       macy.recalculate(true);
//     }, true);

//     window.addEventListener('imageReload', e => {
//       macy.recalculate();
//     })

//   }
// }




function articleColors() {

	// if(window.location.pathname == '/blog') {
	// 	let articles = document.querySelectorAll('.blog_article img');
	// 	articles.forEach((el)=> {
	// 		let imageSrc = el.attributes.src.value;
	// 		let p = new Vibrant.from(imageSrc).quality(1);
	// 		p.getPalette().then((palette) => {
	// 			let container = el.parentNode.parentNode;
	// 			let pill = container.querySelector('.pill');
	// 			let bg = `rgba(${String(palette.LightMuted.rgb)}, 1)`;
	// 			let text = `rgba(${String(palette.Vibrant.rgb)}, 1)`;

	// 			container.style.cssText = `color: ${text};`;
	// 			pill.style.cssText = `background: ${bg}; color: ${text};`;

	// 		});
	// 	});

	// 	let cats = document.querySelectorAll('.blog_highlight img');
	// 	cats.forEach((el)=> {
	// 		let imageSrc = el.attributes.src.value;
	// 		let p = new Vibrant.from(imageSrc).quality(1).maxColorCount(128);
	// 		p.getPalette().then((palette) => {
	// 			let bg = `rgba(${String(palette.LightMuted.rgb)}, 1)`
	// 			let text = `rgba(${String(palette.Vibrant.rgb)}, 1)`
	// 			console.log(bg);
	// 			el.parentNode.parentNode.style.cssText = `
	// 				background: ${bg};
	// 				color: ${text};
	// 			`
	// 		});
	// 	});

	// 	let tiles = document.querySelectorAll('.blog_tile img');
	// 	tiles.forEach((el)=> {
	// 		let imageSrc = el.attributes.src.value;
	// 		let p = new Vibrant.from(imageSrc).quality(3).maxColorCount(256);
	// 		p.getPalette().then((palette) => {
	// 			let bg = `rgba(${String(palette.LightMuted.rgb)}, 1)`
	// 			let text = `rgba(${String(palette.DarkVibrant.rgb)}, 1)`
	// 			console.log(bg);
	// 			el.parentNode.parentNode.style.cssText = `
	// 				background: ${bg};
	// 				color: ${text};
	// 			`
	// 		});
	// 	});
	// }
}




// Align To View — Brief 3D

let scrollSection;
let scrollHeight;
let scrollStart;
let scrollEnd;
let scrollRange;

let videoDuration;
let currentTime = 0;

function scale(number, inMin, inMax, outMin, outMax) {
  return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

function handleLoadedData(event) {
  scrollSection = document.querySelector('.scrollsection');
  scrollHeight  = scrollSection.clientHeight;
  scrollStart = scrollSection.offsetTop;
  scrollEnd = (scrollSection.offsetTop + scrollHeight) - window.innerHeight;
  scrollRange = scrollEnd - scrollStart;
  videoDuration = scrollVideo.duration;
  window.addEventListener('scroll', throttle(handleScrollEvent, 75));
}

// The scroll event handler
function handleScrollEvent(event) {
	// console.log('handleScrollEvent');

	if(window.outerWidth > 600) {
		if(window.scrollY > scrollStart && window.scrollY < scrollEnd) {
			let currScroll = window.scrollY - scrollSection.offsetTop;

			currentTime = scale(currScroll, 0, scrollRange, 0, videoDuration);
			let current = parseFloat(currentTime.toFixed(6));
			// console.log(current + ' / ' + videoDuration);
			scrollVideo.currentTime = current;
		}

		// Pause Intro Video to save us some CPU
		if(document.querySelector('.banner_media video')) {
			if(window.scrollY > window.innerHeight) {
				document.querySelector('.banner_media video').pause()
			} else {
				document.querySelector('.banner_media video').play()
			}
		}
	}

}

function throttle(fn, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
}



// function aosInit() {
//   AOS.init({
//     duration: 450,
//     once: false,
//   });
// }



// function startSliders() {
//   if(document.querySelectorAll('.splide').length) {
//     let perPage = isMobile ? 1.5 : 3.5;
//     let splide = new Splide( '.splide', {
//       type: 'loop',
//       focus  : 'left',
//       perPage: perPage,
//       arrows: true,
//       pagination: false
//     });

//     splide.mount();
//   }

// }

// let cookie = document.querySelector('.cookie');
// function cookieNotice() {
//   l('cookienotice');
//   cookie.addEventListener('click', setCookie);
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   cookie.classList.add('hidden');
// }

function atvImg(){
	var d = document,
		de = d.documentElement,
		bd = d.getElementsByTagName('body')[0],
		htm = d.getElementsByTagName('html')[0],
		win = window,
		imgs = d.querySelectorAll('.atvImg'),
		totalImgs = imgs.length,
		supportsTouch = 'ontouchstart' in win || navigator.msMaxTouchPoints;

	if(totalImgs <= 0){
		return;
	}

	for(var l=0;l<totalImgs;l++){

		var thisImg = imgs[l],
			layerElems = thisImg.querySelectorAll('.atvImg-layer'),
			totalLayerElems = layerElems.length;

		if(totalLayerElems <= 0){
			continue;
		}

		while(thisImg.firstChild) {
			thisImg.removeChild(thisImg.firstChild);
		}

		var containerHTML = d.createElement('div'),
			shineHTML = d.createElement('div'),
			shadowHTML = d.createElement('div'),
			layersHTML = d.createElement('div'),
			layers = [];

		thisImg.id = 'atvImg__'+l;
		containerHTML.className = 'atvImg-container';
		shineHTML.className = 'atvImg-shine';
		shadowHTML.className = 'atvImg-shadow';
		layersHTML.className = 'atvImg-layers';

		for(var i=0;i<totalLayerElems;i++){
			var layer = d.createElement('div'),
				imgSrc = layerElems[i].getAttribute('data-img');

			layer.className = 'atvImg-rendered-layer';
			layer.setAttribute('data-layer',i);
			layer.style.backgroundImage = 'url('+imgSrc+')';
			layersHTML.appendChild(layer);

			layers.push(layer);
		}

		containerHTML.appendChild(shadowHTML);
		containerHTML.appendChild(layersHTML);
		containerHTML.appendChild(shineHTML);
		thisImg.appendChild(containerHTML);

		var w = thisImg.clientWidth || thisImg.offsetWidth || thisImg.scrollWidth;
		thisImg.style.transform = 'perspective('+ w*10 +'px)';

		if(supportsTouch){
			win.preventScroll = false;

	        (function(_thisImg,_layers,_totalLayers,_shine) {
				thisImg.addEventListener('touchmove', function(e){
					if (win.preventScroll){
						e.preventDefault();
					}
					processMovement(e,true,_thisImg,_layers,_totalLayers,_shine);
				});
	            thisImg.addEventListener('touchstart', function(e){
	            	win.preventScroll = true;
					processEnter(e,_thisImg);
				});
				thisImg.addEventListener('touchend', function(e){
					win.preventScroll = false;
					processExit(e,_thisImg,_layers,_totalLayers,_shine);
				});
	        })(thisImg,layers,totalLayerElems,shineHTML);
	    } else {
	    	(function(_thisImg,_layers,_totalLayers,_shine) {
				thisImg.addEventListener('mousemove', function(e){
					processMovement(e,false,_thisImg,_layers,_totalLayers,_shine);
				});
	            thisImg.addEventListener('mouseenter', function(e){
					processEnter(e,_thisImg);
				});
				thisImg.addEventListener('mouseleave', function(e){
					processExit(e,_thisImg,_layers,_totalLayers,_shine);
				});
	        })(thisImg,layers,totalLayerElems,shineHTML);
	    }
	}

	function processMovement(e, touchEnabled, elem, layers, totalLayers, shine){
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
		} else {

			var bdst = bd.scrollTop || htm.scrollTop,
				bdsl = bd.scrollLeft,
				pageX = (touchEnabled)? e.touches[0].pageX : e.pageX,
				pageY = (touchEnabled)? e.touches[0].pageY : e.pageY,
				offsets = elem.getBoundingClientRect(),
				w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth,
				h = elem.clientHeight || elem.offsetHeight || elem.scrollHeight,
				wMultiple = 320/w,
				offsetX = 0.52 - (pageX - offsets.left - bdsl)/w,
				offsetY = 0.52 - (pageY - offsets.top - bdst)/h,
				dy = (pageY - offsets.top - bdst) - h / 2,
				dx = (pageX - offsets.left - bdsl) - w / 2,
				yRotate = (offsetX - dx)*(0.07 * wMultiple),
				xRotate = (dy - offsetY)*(0.1 * wMultiple),
				imgCSS = 'rotateX(' + xRotate + 'deg) rotateY(' + yRotate + 'deg)',
				arad = Math.atan2(dy, dx),
				angle = arad * 180 / Math.PI - 90;

			if (angle < 0) {
				angle = angle + 360;
			}

			if(elem.firstChild.className.indexOf(' over') != -1){
				imgCSS += ' scale3d(1.07,1.07,1.07)';
			}
			elem.firstChild.style.transform = imgCSS;

			// shine.style.background = 'linear-gradient(' + angle + 'deg, rgba(255,255,255,' + (pageY - offsets.top - bdst)/h * 0.4 + ') 0%,rgba(255,255,255,0) 80%)';
			// shine.style.transform = 'translateX(' + (offsetX * totalLayers) - 0.1 + 'px) translateY(' + (offsetY * totalLayers) - 0.1 + 'px)';

			var revNum = totalLayers;
			for(var ly=0;ly<totalLayers;ly++){
				layers[ly].style.transform = 'translateX(' + (offsetX * revNum) * ((ly * 1.5) / wMultiple) + 'px) translateY(' + (offsetY * totalLayers) * ((ly * 1.5) / wMultiple) + 'px)';
				revNum--;
			}
		}
	}

	function processEnter(e, elem){
		elem.firstChild.className += ' over';
	}

	function processExit(e, elem, layers, totalLayers, shine){

		var container = elem.firstChild;

		container.className = container.className.replace(' over','');
		container.style.transform = '';
		shine.style.cssText = '';

		for(var ly=0;ly<totalLayers;ly++){
			layers[ly].style.transform = '';
		}

	}

}
